<template>
  <div class="chat-workbench-host">
    <AgentServiceWindow ref="window" :show="ui.open && !pageTarget" dockable :docked="ui.docked"
      :sidebar-width="headerExpanded ? 260 : 0" :pinned="ui.pinned" :title="profile.name || $t('chatWorkbench.title')" :initial="profile.initial || '聊'" :show-presence="false"
      @update:docked="$store.commit('chatWorkbench/dock', $event)"
      @update:pinned="$store.commit('chatWorkbench/pin', $event)" @update:show="close">

      <template #header-sidebar><div ref="searchTarget" class="header-search-target" /></template>

      <div ref="floatingTarget" class="floating-workbench-target" />
    </AgentServiceWindow>
    <div ref="parking" hidden>
      <ChatWorkbench v-if="identity" :key="identity" ref="workspace" @profile-change="profile = $event" :floating="!pageTarget" @layout-change="headerExpanded = $event; $nextTick(relocate)" :visible="Boolean(pageTarget || (ui.open && !ui.docked))" />
    </div>
  </div>
</template>
<script>
import AgentServiceWindow from "@/components/agent-service/AgentServiceWindow.vue";
import ChatWorkbench from "./ChatWorkbench.vue";
import { observeChatWorkbenchTarget } from "@/services/chat-workbench-mount";
import { resolveAgentServiceCurrentUserId } from "@/services/agent-service-state";
export default {
  name: "ChatWorkbenchHost",
  components: { AgentServiceWindow, ChatWorkbench },
  data: () => ({ pageTarget: null, profile: {}, headerExpanded: false }),
  computed: {
    ui() { return this.$store.state.chatWorkbench; },
    identity() {
      const token = String(this.$store.state.user?.userInfo?.token || "");
      return token ? `${resolveAgentServiceCurrentUserId(this.$store.state.user || {})}:${token}` : "";
    },
    generalRequestVersion() { return this.$store.state.agentServiceUi.generalRequestVersion; },
  },
  watch: {
    identity() { this.profile = {}; this.park(); this.$store.commit('chatWorkbench/reset'); this.$nextTick(this.relocate); },
    generalRequestVersion() { this.$store.commit('chatWorkbench/open', { kind: 'GENERAL' }); },
    'ui.requestVersion'() { this.$nextTick(this.applyRequest); },
    'ui.open'() { this.$nextTick(this.relocate); },
  },
  mounted() {
    this.stopObserving = observeChatWorkbenchTarget(target => {
      this.$refs.workspace?.captureReadingPosition(); this.park();
      const wasPage = Boolean(this.pageTarget);
      this.pageTarget = target;
      if (target) this.$store.commit('chatWorkbench/show');
      this.$nextTick(() => {
        this.relocate();
        if (wasPage && !target && !this.ui.pinned) this.$refs.window?.dockWindow();
      });
    });
    this.applyRequest();
  },
  beforeDestroy() { this.park(); this.stopObserving?.(); },
  methods: {
    park() { this.$refs.workspace?.relocateChrome({}); const el = this.$refs.workspace?.$el; if (el && this.$refs.parking) this.$refs.parking.appendChild(el); },
    relocate() {
      const el = this.$refs.workspace?.$el;
      const target = this.pageTarget || (this.ui.open ? this.$refs.floatingTarget : this.$refs.parking);
      if (el && target && el.parentNode !== target) target.appendChild(el);
      this.$refs.workspace?.relocateChrome({
        searchTarget: !this.pageTarget && this.ui.open ? this.$refs.searchTarget : null,
      });
      this.$refs.workspace?.restoreReadingPosition();
    },
    async applyRequest() {
      const request = this.ui.request;
      this.relocate();
      if (request?.expand) {
        await this.$nextTick();
        if (request !== this.ui.request || !this.ui.open) return;
        this.$refs.window?.expandWidth();
        this.$refs.workspace?.expandConversations();
      }
      this.$refs.workspace?.openRequest(request);
    },
    async close() {
      await this.$refs.workspace?.closeFloating(); this.park();
      this.$store.commit('chatWorkbench/close'); this.$store.commit('agentServiceUi/closeGeneral');
    },
  },
};
</script>
<style scoped>
.header-search-target { width: 100%; min-width: 0; }
.floating-workbench-target { display: flex; flex-direction: column; height: 100%; min-height: 0; flex: 1; overflow: hidden; }
</style>
